export default "__VITE_ASSET__Cm1nr5HO__"